import { PowerDialerEvent } from "@/model/interface/PowerDialerEvent";
import { socketClient } from "@/services/socketClient";
import { useSocketSubscription } from "@/hooks/useSocketSubscription";

interface PowerDialerSocketHandlers {
  onCampaignEvent: (event: PowerDialerEvent) => void;
  onSessionEvent: (event: PowerDialerEvent) => void;
  onConnected?: () => void;
  onSessionSubscribed?: () => void;
}

function parseEvent(body: string): PowerDialerEvent | null {
  try {
    return JSON.parse(body);
  } catch (error) {
    console.error("Failed to parse power dialer event:", error);
    return null;
  }
}

export function usePowerDialerSocket(
  campaignId: string | null,
  sessionId: string | null,
  handlers: PowerDialerSocketHandlers,
) {
  useSocketSubscription(
    campaignId ? `/topic/power-dialer/${campaignId}` : null,
    (message) => {
      const event = parseEvent(message.body);
      if (event) {
        handlers.onCampaignEvent(event);
      }
    },
    () => handlers.onConnected?.(),
  );

  useSocketSubscription(
    campaignId && sessionId ? `/topic/power-dialer/session/${sessionId}` : null,
    (message) => {
      const event = parseEvent(message.body);
      if (event) {
        handlers.onSessionEvent(event);
      }
    },
    () => {
      socketClient.publish("/app/power-dialer/attach", { sessionId });
      handlers.onSessionSubscribed?.();
    },
  );
}
